<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Chip
    unstyled
    :pt="theme"
    :pt-options="{
      mergeProps: ptViewMerge,
    }"
  >
    <template #removeicon="{ removeCallback, keydownCallback }">
      <TimesCircleIcon
        class="cursor-pointer text-sm w-4 h-4 rounded-full focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary"
        :class="gradient ? 'text-primary' : 'text-surface-800 dark:text-surface-0'"
        @click="removeCallback"
        @keydown="keydownCallback"
      />
    </template>
    <template v-for="(_, slotName) in $slots" #[getTypedSlotName(slotName)]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Chip>
</template>

<script setup lang="ts">
import TimesCircleIcon from "@primevue/icons/times";
import Chip, {
  type ChipPassThroughOptions,
  type ChipProps,
  type ChipSlots,
} from "primevue/chip";
import { ref } from "vue";
import { createSlotPassThroughGetter, ptViewMerge } from "./utils";

const getTypedSlotName = createSlotPassThroughGetter<ChipSlots>();

interface Props extends /* @vue-ignore */ ChipProps {
  gradient?: boolean;
}
const props = defineProps<Props>();

const theme = ref<ChipPassThroughOptions>({
  root: `${
    props.gradient
      ? "bg-gradient-to-r from-ma-turquoise/30 via-ma-sky/30 to-ma-blue/40 text-primary font-medium ma-shadow rounded-lg"
      : "bg-surface-100 dark:bg-surface-800 text-surface-800 dark:text-surface-0 rounded-lg"
  }
        inline-flex items-center gap-2 px-3 py-2
        text-sm
        has-[img]:pt-1 has-[img]:pb-1
        p-removable:pe-2`,
  image: `rounded-full w-8 h-8 -ms-2`,
  icon: `text-surface-800 dark:text-surface-0 text-base w-4 h-4`,
});
</script>
